import ajax from '../http/ajax'
// 统一下单支付接口
export const postPaymentent = params => {
    return ajax.post('outTradeNo', params)
}
// 获取订单状态
export const getOrderStatus = params => {
    return ajax.post('notify', params)
}
// 支付成功的页面
export const getPayDetail = params => {
    return ajax.post('payedOrder', params)
}

// 储值卡支付
export const goDebitcard = data => {
    return ajax.post('debitcard', data)
}
